import { useState, useCallback, useEffect } from 'react';
import copyToClipboard from 'copy-to-clipboard';

export default (text, timeout = 2000) => {
  const [copied, setCopied] = useState(false);

  const copy = useCallback(() => {
    copyToClipboard(text);
    setCopied(true);
  }, [text]);

  useEffect(() => {
    if (!copied) return;
    const to = setTimeout(() => setCopied(false), timeout);

    return () => clearTimeout(to);
  }, [copied]);

  return [copied, copy];
};
